// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

// constants
import { BOOKING_NATURES, BOOKING_SOURCES } from "../../../constants/booking";

type BookingEstimateParseDataReturnType = {
  roomReference: string;
  channelId: string;
  nature: keyof typeof BOOKING_NATURES;
  source: keyof typeof BOOKING_SOURCES;
  checkin: string;
  checkout: string;
  departure: string;
  arrival: string;
  insuranceAmount: number;
  serviceFeeAmount: number;
  baseServiceFeeAmount: number;
  touristTaxAmount: number;
  duration: number;
  tripAmount: number;
  periodsAmountWithoutDiscounts: number;
  customerPeriodsAmountWithoutDiscounts: number;
  discountsAmount: number;
  discountList: Array<{
    name: string;
    code: string;
  }>;
  optionList: Array<{
    quantity: number;
    amount: number;
    name: string;
  }>;
  discountServiceFeeAmount: number;
  advanceAmount: number;
  advanceMaxDueDate: string;
  numberOfAdults: number;
  numberOfChildren: number;
  numberOfBabies: number;
  numberOfPets: number;
  numberOfCats: number;
  numberOfDogs: number;
  metas: {
    ancvConnectAuthorizedTransactionStatus: {
      amount: number;
      expires_at: string;
    };
  };
};

const bookingEstimateParseData = ({
  rawResponseData,
}): BookingEstimateParseDataReturnType => {
  return {
    roomReference: get(rawResponseData, "roomRef"),
    channelId: get(rawResponseData, "channelId"),
    nature: get(rawResponseData, "nature"),
    source: get(rawResponseData, "source"),
    checkin: get(rawResponseData, "checkin"),
    checkout: get(rawResponseData, "checkout"),
    departure: get(rawResponseData, "departure"),
    arrival: get(rawResponseData, "arrival"),
    tripAmount: get(rawResponseData, "tripAmount"),
    insuranceAmount: get(rawResponseData, "insuranceAmount"),
    serviceFeeAmount: get(rawResponseData, "serviceFeeAmount"),
    baseServiceFeeAmount: get(rawResponseData, "baseServiceFeeAmount"),
    touristTaxAmount: get(rawResponseData, "touristTaxAmount"),
    duration: get(rawResponseData, "metas.duration"),
    periodsAmountWithoutDiscounts: get(
      rawResponseData,
      "metas.periodsAmountWithoutDiscounts"
    ),
    customerPeriodsAmountWithoutDiscounts: get(
      rawResponseData,
      "metas.customerPeriodsAmountWithoutDiscounts"
    ),
    discountsAmount: get(rawResponseData, "discountsAmount"),
    discountList: get(rawResponseData, "discounts", []).map((discount) => ({
      name: discount.name,
      code: discount.code,
    })),
    optionList: get(rawResponseData, "options", []),
    discountServiceFeeAmount: get(rawResponseData, ""),
    advanceAmount: get(rawResponseData, "metas.advance.amount"),
    advanceMaxDueDate: get(rawResponseData, "metas.advance.dueDate"),
    numberOfAdults: get(rawResponseData, "adults"),
    numberOfChildren: get(rawResponseData, "childs"),
    numberOfBabies: get(rawResponseData, "babies"),
    numberOfPets: get(rawResponseData, "pets"),
    numberOfCats: get(rawResponseData, "cats"),
    numberOfDogs: get(rawResponseData, "dogs"),
    metas: {
      ancvConnectAuthorizedTransactionStatus: get(
        rawResponseData,
        "metas.ancvConnectAuthorizedTransactionStatus"
      ),
    },
  };
};

export default bookingEstimateParseData;
